var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgThermometer = function SvgThermometer(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "thermometer_svg__svg-icon"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#thermometer_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 3.5v11.26a4.5 4.5 0 1 1-5 0V3.5a2.5 2.5 0 1 1 5 0Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "thermometer_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h24v24H0z"
  })))));
};

export { SvgThermometer as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjQgMjQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgY2xhc3M9InN2Zy1pY29uIj48ZyBjbGlwLXBhdGg9InVybCgjY2xpcDBfNTEwNl8xNjYzNikiPjxwYXRoIGQ9Ik0xNCAzLjVWMTQuNzZDMTQuODAyNyAxNS4yOTYzIDE1LjQxMTcgMTYuMDc2NiAxNS43MzY5IDE2Ljk4NTZDMTYuMDYyMiAxNy44OTQ2IDE2LjA4NjUgMTguODg0MSAxNS44MDYyIDE5LjgwNzlDMTUuNTI2IDIwLjczMTcgMTQuOTU2MSAyMS41NDEgMTQuMTgwNyAyMi4xMTYxQzEzLjQwNTIgMjIuNjkxMiAxMi40NjU0IDIzLjAwMTcgMTEuNSAyMy4wMDE3QzEwLjUzNDYgMjMuMDAxNyA5LjU5NDc2IDIyLjY5MTIgOC44MTkzNCAyMi4xMTYxQzguMDQzOTEgMjEuNTQxIDcuNDczOTkgMjAuNzMxNyA3LjE5Mzc2IDE5LjgwNzlDNi45MTM1MiAxOC44ODQxIDYuOTM3ODIgMTcuODk0NiA3LjI2MzA3IDE2Ljk4NTZDNy41ODgzMiAxNi4wNzY2IDguMTk3MjggMTUuMjk2MyA5IDE0Ljc2VjMuNUM5IDIuODM2OTYgOS4yNjMzOSAyLjIwMTA3IDkuNzMyMjMgMS43MzIyM0MxMC4yMDExIDEuMjYzMzkgMTAuODM3IDEgMTEuNSAxQzEyLjE2MyAxIDEyLjc5ODkgMS4yNjMzOSAxMy4yNjc4IDEuNzMyMjNDMTMuNzM2NiAyLjIwMTA3IDE0IDIuODM2OTYgMTQgMy41WiIgc3Ryb2tlPSJjdXJyZW50Q29sb3IiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+PC9nPjxkZWZzPjxjbGlwUGF0aCBpZD0iY2xpcDBfNTEwNl8xNjYzNiI+PHJlY3Qgd2lkdGg9IjI0IiBoZWlnaHQ9IjI0IiBmaWxsPSJjdXJyZW50Q29sb3IiLz48L2NsaXBQYXRoPjwvZGVmcz48L3N2Zz4=";